import BaseController from "@stimulus-components/chartjs"

export class Controller extends BaseController {
  connect() {
    super.connect()
  }

  get defaultOptions() {
    return {
      responsive: true,
      maintainAspectRatio: true,
      plugins: {
        title: {
          display: true,
          text: "Historical prices",
          font: {
            size: 16,
            weight: "bold",
          },
        },
        tooltip: {
          mode: "index",
          intersect: false,
          callbacks: {
            label: (context) => `$${context.parsed.y.toFixed(2)} per ${context.raw.unit}`,
          },
        },
        legend: {
          display: true,
          position: "top",
        },
      },
      interaction: {
        mode: "nearest",
        axis: "x",
        intersect: false,
      },
      scales: {
        x: {
          type: "category",
          title: {
            display: true,
            text: "Date",
          },
          ticks: {
            autoSkip: true,
            maxTicksLimit: 10,
          },
        },
        y: {
          title: {
            display: true,
            text: "Price (USD)",
          },
          beginAtZero: false,
          ticks: {
            callback: (value) => `$${value.toFixed(2)}`,
          },
        },
      },
    }
  }
}
